const types = {
    SET_LIST: '[ADMIN] LIST ADMIN',
    SET_HISTORY: '[ADMIN] LIST HISTORY',
    SET_EVENT: '[ADMIN] LIST EVENTS',
}

export {
    types
}